(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adl-brand-marquee"] && !Shopify.designMode) return;
  try {
    
function initializeBrandMarquees(root=document){
 root.querySelectorAll('[data-brand-marquee]').forEach(section=>{
  if(section.dataset.ready)return;section.dataset.ready='true';
  const toggle=section.querySelector('[data-brand-pause]');
  const pause=paused=>{
   section.toggleAttribute('data-paused',paused);toggle.setAttribute('aria-pressed',String(paused));
   const label=paused?toggle.dataset.playLabel:toggle.dataset.pauseLabel;
   toggle.setAttribute('aria-label',label);toggle.querySelector('[data-brand-pause-text]').textContent=label;toggle.querySelector('[data-brand-pause-icon]').textContent=paused?'▶':'Ⅱ';
  };
  toggle.addEventListener('click',()=>{pause(!section.hasAttribute('data-paused'));});
  section.querySelector('.adl-brand-marquee-window').addEventListener('pointerdown',event=>{if(event.pointerType==='touch')pause(true);},{passive:true});
 });
}
initializeBrandMarquees();document.addEventListener('shopify:section:load',event=>initializeBrandMarquees(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adl-customer-catalogs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', async event => {
  const link = event.target.closest('[data-catalog-download]');
  if (!link) return;
  event.preventDefault();
  if (link.getAttribute('aria-busy') === 'true') return;
  link.setAttribute('aria-busy','true');
  const error = link.closest('article').querySelector('[data-download-error]');
  error.hidden = true;
  try {
    const response = await fetch(link.href, {credentials:'omit'});
    if (!response.ok) throw new Error('Download failed');
    const url = URL.createObjectURL(await response.blob());
    const download = document.createElement('a');
    download.href = url;
    download.download = link.download;
    document.body.appendChild(download);
    download.click();
    download.remove();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch {
    error.hidden = false;
  } finally {
    link.removeAttribute('aria-busy');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adl-footer"]) return;
  try {
    
function initializeAromaFooters(){document.querySelectorAll('[data-adl-footer]').forEach(footer=>{if(footer.dataset.initialized)return;footer.dataset.initialized='true';if(window.matchMedia('(max-width: 600px)').matches){footer.querySelectorAll('details:not([data-keep-open])').forEach(panel=>{panel.open=false;});}});}
initializeAromaFooters();document.addEventListener('shopify:section:load',initializeAromaFooters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adl-product-carousel"] && !Shopify.designMode) return;
  try {
    
function initializeDiscoveryRails(root=document){
  root.querySelectorAll('[data-adl-rail]').forEach(rail=>{
    if(rail.dataset.ready)return;
    rail.dataset.ready='true';
    const track=rail.querySelector('[data-adl-track]');
    const prev=rail.querySelector('[data-adl-prev]');
    const next=rail.querySelector('[data-adl-next]');
    const refresh=()=>{const overflow=track.scrollWidth>track.clientWidth+4;prev.hidden=!overflow;next.hidden=!overflow;prev.disabled=track.scrollLeft<=4;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-4;};
    const move=direction=>track.scrollBy({left:direction*track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
    track.addEventListener('scroll',refresh,{passive:true});
    if('ResizeObserver' in window)new ResizeObserver(refresh).observe(track);
    refresh();
  });
}
initializeDiscoveryRails();
document.addEventListener('shopify:section:load',event=>initializeDiscoveryRails(event.target));

  } catch(e) { console.error(e); }
})();
})();
